function ScenarioPlannerIcon({ color }: { color: string }) {
    const svgString = `<svg
width="31"
height="31"
viewBox="0 0 16 16"
version="1.1"
id="svg1"
xml:space="preserve"
xmlns="http://www.w3.org/2000/svg"
xmlns:svg="http://www.w3.org/2000/svg"
>
<defs id="defs1" />
<g id="layer1">
  <g
    id="g30"
    transform="matrix(1.233033,0,0,1.2093379,-2.0681683,-0.81537477)"
  >
    <circle
      style="
        fill:${color};fill-opacity:1;stroke-width:1.84542;paint-order:fill markers stroke'
      "
      id="path1"
      cx="3.1773016"
      cy="5.6971912"
      r="1.5"
    />
    <rect
      style="
        fill:${color};fill-opacity:1;stroke-width:636.876;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="rect24"
      width="4.0001402"
      height="1"
      x="2.3121092"
      y="5.1971912"
      ry="0.57882911"
    />
    <rect
      style="
        fill:${color};fill-opacity:1;stroke-width:740.369;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="rect24-6"
      width="5.4058108"
      height="1"
      x="-10.603003"
      y="5.3122492"
      transform="rotate(-90)"
      ry="0.5714286"
    />
    <rect
      style="
        fill:${color};fill-opacity:1;stroke-width:755.286;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="rect24-8"
      width="5.6258373"
      height="1"
      x="5.3122492"
      y="9.6030025"
      ry="0.57142854"
    />
    <rect
      style="
        fill:${color};fill-opacity:1;stroke-width:536.66;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="rect25"
      width="1"
      height="10.250608"
      x="10.418624"
      y="2.6988602"
      ry="0.421"
    />
    <rect
      style="
        fill:${color};fill-opacity:1;stroke-width:924.474;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="rect24-0"
      width="8.428627"
      height="1"
      x="2.9899967"
      y="12.063487"
      ry="0.5714286"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42"
      cx="-10.080454"
      cy="-8.7346621"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(-0.83807372,0.545557,-0.49352771,-0.86973007,0,0)"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42-3"
      cx="-8.8314743"
      cy="-10.855593"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(-0.83807372,0.545557,-0.49352771,-0.86973007,0,0)"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42-3-8"
      cx="-7.6064587"
      cy="-12.935827"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(-0.83807372,0.545557,-0.49352771,-0.86973007,0,0)"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42-1"
      cx="8.9368782"
      cy="3.1720953"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(0.83807372,0.545557,0.49352771,-0.86973007,0,0)"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42-3-87"
      cx="10.185861"
      cy="1.0511652"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(0.83807372,0.545557,0.49352771,-0.86973007,0,0)"
    />
    <ellipse
      style="
        fill:${color};fill-opacity:1;stroke-width:390.033;stroke-dasharray:none;paint-order:stroke fill markers'
      "
      id="path29-42-3-8-8"
      cx="11.410875"
      cy="-1.0290685"
      rx="2.2004864"
      ry="0.8786968"
      transform="matrix(0.83807372,0.545557,0.49352771,-0.86973007,0,0)"
    />
    <circle
      style="
        fill:${color};fill-opacity:1;stroke-width:1.84542;paint-order:fill markers stroke'
      "
      id="path1-9"
      cx="3.1773016"
      cy="12.404613"
      r="1.5"
    />
  </g>
</g>
</svg>`;
    return <div dangerouslySetInnerHTML={{ __html: svgString }} />;
}

export default ScenarioPlannerIcon;
